
export function langdetector() {

	let lang = location.host.split(".").pop();

	if(lang.indexOf('localhost') != -1){
		lang = "es";
	}
	localStorage.setItem('language', lang);  
	(lang == 'com') ? lang = 'es' : null;
	(lang == 'app') ? lang = 'es' : null;
	(lang == 'es') ? lang = 'es' : null;
	return lang;
	


}


// WEBPACK FOOTER //
// ./src/langdetector/index.js